module.exports = __webpack_public_path__ + "img/dynameat-logo-long-dark.2ca631e4.png";